module.exports = __webpack_public_path__ + "img/no-user-pic.46023b30.svg";